"use client";
import { Button } from "@/components/ui/button";
import { Menu, XIcon } from "lucide-react";
import { Sheet, SheetClose, SheetContent, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import TextbookSidebar, { type TextbookSidebarProps } from "./TextbookSidebar";

export default function TextbookMobileNav({ groupedTopics }: Pick<TextbookSidebarProps, "groupedTopics">) {
  return (
    <div className="md:hidden">
      <Sheet>
        <SheetTrigger asChild>
          <Button variant="ghost" size="icon" aria-label="Open textbook contents">
            <Menu className="h-6 w-6" />
          </Button>
        </SheetTrigger>
        <SheetContent side="left" className="w-[280px] border-sidebar-border bg-sidebar p-0">
          <SheetTitle className="sr-only">Textbook contents</SheetTitle>
          <SheetClose className="absolute right-3 top-5 rounded-lg p-1 text-sidebar-foreground/70 hover:bg-sidebar-accent hover:text-sidebar-foreground">
            <XIcon className="h-5 w-5" />
          </SheetClose>
          <TextbookSidebar groupedTopics={groupedTopics} />
        </SheetContent>
      </Sheet>
    </div>
  );
}
